import { Center, CenterProps } from "@chakra-ui/react";
import Loading from "./Loading";

interface CenteredLoadingProps {
  height?: CenterProps["h"];
}

const CenteredLoading = ({ height = "100vh" }: CenteredLoadingProps) => {
  return (
    <Center h={height}>
      <Loading />
    </Center>
  );
};

export default CenteredLoading;
